import {
    drawerWidth,
    drawerMiniWidth,
    transition,
    containerFluid,
} from "../../material-dashboard-pro-react.js";

const appStyle = (theme) => ({
    // html: {
    //   margin: 0,
    //   padding:0,
    //   height: '100%'
    // },
    // body: {
    //   margin: 0,
    //   padding:0,
    //   height: '100%'
    // },
    wrapper: {
        position: "relative",
        top: "0",
        height: "100vh",
        // overflowX: 'hidden',
        "&:after": {
            display: "table",
            clear: "both",
            content: '" "',
        },
        // On mobile we let the document scroll naturally rather than
        // pinning the wrapper to 100vh and nesting a scrollable
        // mainPanel inside it. Pinning to 100vh causes a "double
        // scroll" effect on iOS / Android: the outer wrapper can rubber-
        // band a little before the inner mainPanel actually scrolls.
        "@media (max-width: 599px)": {
            height: "auto",
            minHeight: "100vh",
        },
    },
    mainPanel: {
        transitionProperty: "top, bottom, width",
        transitionDuration: ".2s, .2s, .35s",
        transitionTimingFunction: "linear, linear, ease",
        "@media (min-width: 600px)": {
            width: `calc(100% - ${drawerWidth}px - 16px)`,
        },
        overflow: "auto",
        position: "relative",
        float: "right",
        ...transition,
        maxHeight: "100%",
        width: "100%",
        overflowScrolling: "touch",
        // Disable the inner scroll container on small viewports so the
        // page scrolls as a single surface (the document/window) — this
        // is what users expect on mobile and avoids the "two scroll
        // areas" issue described above.
        "@media (max-width: 599px)": {
            overflow: "visible",
            maxHeight: "none",
            float: "none",
        },
    },
    content: {
        marginTop: "70px",
        padding: "0px 15px 30px 15px",
        minHeight: "calc(100vh - 123px)",
    },
    container: { ...containerFluid },
    map: {
        marginTop: "70px",
    },
    mainPanelSidebarMini: {
        "@media (min-width: 600px)": {
            width: `calc(100% - ${drawerMiniWidth}px)`,
        },
    },
    mainPanelWithPerfectScrollbar: {
        overflow: "hidden !important",
    },
});

export default appStyle;
